import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import OrganizationFunctionsService from "src/modules/data-protection/apis/OrganizationFunctionsService";
import {
    ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY,
    extractOrganizationFunction,
    toastOrganizationFunctionError,
} from "src/modules/data-protection/constants/organizationFunctions";
import { ROUTE_PATH_ADMIN_USER_LIST } from "src/modules/data-protection/constants";

const useCreateOrganizationFunction = ({ t, onSuccess } = {}) => {
    const history = useHistory();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const service = OrganizationFunctionsService.getInstance();
            return await service.create(payload);
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries(ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY);
            toast(t("Function created successfully."), {
                type: "success",
            });

            if (onSuccess) {
                onSuccess(data);
            }

            const created = extractOrganizationFunction(data);

            if (created?.key) {
                history.push(
                    `${ROUTE_PATH_ADMIN_USER_LIST}/functions/${created.key}`
                );
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toastOrganizationFunctionError(
                error,
                t,
                "An error occurred while creating the Function."
            );
        },
    });
};

export default useCreateOrganizationFunction;
